import { Navigate } from "react-router-dom";
import { LOGIN_ROUTE } from "../routes/web/rootRoutes";
import authManager from "../utils/authManager";

const UserPartnerAuth = ({ children }) => {
  if (authManager.hasAccessToken()) {
    return children;
  } else {
    return <Navigate to={LOGIN_ROUTE} replace />;
  }
};

export default UserPartnerAuth;
